const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/transfers.tsx?tsr-split=component');
const $$splitErrorComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/transfers.tsx?tsr-split=errorComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireCapabilities } from '@/features/authentication/lib/routeGuards';
import { UploadsPageSkeleton } from '@/features/uploads/components/UploadsPageSkeleton';
import { mySourceImportsQuery, mySubmissionsQuery } from '@/features/uploads/services/uploadQueries';
import { getCurrentAuthUser } from '@/shared/lib/authSession';
import { createFileRoute } from '@tanstack/react-router';

/** The Transfers center. Internal implementation remains in the uploads feature. */
export const Route = createFileRoute('/_authenticated/_app/transfers')({
  beforeLoad: requireCapabilities(has => has('submissions.list') || has('source-imports.list') || has('ingestion-audit.list')),
  loader: async ({
    context
  }) => {
    const uid = getCurrentAuthUser()?.uid;
    if (!uid) return;
    await Promise.all([context.queryClient.ensureInfiniteQueryData(mySubmissionsQuery(uid)).catch(() => {}), context.queryClient.ensureInfiniteQueryData(mySourceImportsQuery(uid)).catch(() => {})]);
  },
  pendingComponent: UploadsPageSkeleton,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});